
import { LocationVarKey } from '@swivl-mono/types';
import { WorksheetComponent, WorksheetComponentType } from '../../../Components/Worksheets/WorksheetComponent/WorksheetComponent.Component';
import {
  WorksheetColumn,
  WorksheetLayout,
  WorksheetRow,
} from '../../../Components/Worksheets/Layout/Worksheet.Layout.Components';
import { usePropertiesGetLocationIds } from '../../../Hooks/usePropertiesGetLocationIds';
import { IS_NOT_EQUAL } from '../../../Components/Worksheets/Types/Worksheet.Interface';
export default function LocationSubpageInformation() {
  const page = usePropertiesGetLocationIds();

  
  return (
    <WorksheetLayout>
        <h4>Storage Types</h4>
        <WorksheetRow>
        <WorksheetColumn>
        <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Vehicle Storage"
            keyName={LocationVarKey.HasVehicleStorage}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Small Vehicle"
            hideIf={IS_NOT_EQUAL(LocationVarKey.HasVehicleStorage,"1")}
            keyName={LocationVarKey.HasSmallVehicleStorage}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Indoor Vehicle"
            hideIf={IS_NOT_EQUAL(LocationVarKey.HasVehicleStorage,"1")}
            keyName={LocationVarKey.HasIndoorVehicleStorage}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Outdoor Vehicle"
            hideIf={IS_NOT_EQUAL(LocationVarKey.HasVehicleStorage,"1")}
            keyName={LocationVarKey.HasOutdoorVehicleStorage}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Covered Vehicle"
            hideIf={IS_NOT_EQUAL(LocationVarKey.HasVehicleStorage,"1")}
            keyName={LocationVarKey.HasCoveredVehicleStorage}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="RV"
            keyName={LocationVarKey.HasRVParking}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Covered RV"
            hideIf={IS_NOT_EQUAL(LocationVarKey.HasRVParking,"1")}
            keyName={LocationVarKey.HasRVParkingCovered}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Enclosed RV"
            hideIf={IS_NOT_EQUAL(LocationVarKey.HasRVParking,"1")}
            keyName={LocationVarKey.HasRVParkingEnclosed}
          />
        </WorksheetColumn>



        <WorksheetColumn>
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Trailer"
            keyName={LocationVarKey.HasTrailerStorage}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Business Storage"
            keyName={LocationVarKey.HasBusinessStorage}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Lockers"
            keyName={LocationVarKey.HasLockers}
          />
          <WorksheetComponent
              componentType={WorksheetComponentType.SWITCH}
              {...page}
              label="Wine"
              keyName={LocationVarKey.HasWineStorage}
          />
          <WorksheetComponent
              componentType={WorksheetComponentType.SWITCH}
              {...page}
              label="Boat"
              keyName={LocationVarKey.HasBoatStorage}
          />
        </WorksheetColumn>
      </WorksheetRow>
    </WorksheetLayout>
  );
}
